import ConvertUkTimeZone from "../convert-time-zone";
import CheckDay from "./CheckDay";
import GetHourMinutes from "./GetHourMinutes";
function CheckMarketOpenClose(data: any, isPre = false) {
  if (!data) {
    return {};
  } else if (data.length > 0) {
    //Start check previous Day ............................................
    const previousDay = data?.find((item: any) => {
      return (
        item?.available_days == CheckDay(false) &&
        item.status == "open" &&
        item.availability != null
      );
    });
    // Konsole.log('previousDay',previousDay,data)
    const previous  =previousDay?.availability?.find((item: any) => {
      const timing = GetHourMinutes(item?.to_time);
      // Konsole.log('timingtiming',timing,item)
      return (
        item.next_day == 1 &&
        ConvertUkTimeZone().set({
          hour: timing.hours || 0,
          minute: timing.minutes || 0,
          second: 0,
        }) > ConvertUkTimeZone()
      );
    });
    if (previous) {
      return { data: previous, pre: false, yesterday: true };
    }
    //End check previous Day ............................................

    // check current day open or not ...................................
    const currentDay = data?.find((item: any) => {
      return (
        item?.available_days == CheckDay(true) &&
        item.status == "open" &&
        item.availability != null
      );
    });
    const current = currentDay?.availability?.find((item: any) => {
      const fromTiming = GetHourMinutes(item?.from_time);
      const toTiming = GetHourMinutes(item?.to_time);
      if ( item.next_day == 0 &&
        ConvertUkTimeZone().set({
          hour: fromTiming.hours || 0,
          minute: fromTiming.minutes || 0,
          second: 0,
        }) < ConvertUkTimeZone() &&
        ConvertUkTimeZone().set({
          hour: toTiming.hours || 0,
          minute: toTiming.minutes || 0,
          second: 0,
        }) > ConvertUkTimeZone()
      ) {
        return item;
      } else if (
        item.next_day == 1 &&
        ConvertUkTimeZone().set({
          hour: fromTiming.hours || 0,
          minute: fromTiming.minutes || 0,
          second: 0,
        }) < ConvertUkTimeZone()
      ) {
        return item;
      } else {
        return;
      }
    });
    if (current) {
      return { data: current, pre: false, yesterday: false };
    }
    // End Check current day open or not ...............................

    // Start pre order day ..................................................
    if (!isPre) {
      return {};
    }
    const pre = currentDay?.availability?.find((item: any) => {
      const toTiming = GetHourMinutes(item?.from_time); // from time

      return (
        // item.next_day == 0 &&
        ConvertUkTimeZone().set({
          hour: toTiming.hours || 0,
          minute: toTiming.minutes || 0,
          second: 0,
        }) > ConvertUkTimeZone()
      );
    });
    if (pre) {
      return { data: pre, pre: true, yesterday: false };
    }
    // end check pre order day .................................................

    return {};
  } else {
    return {};
  }
}
export default CheckMarketOpenClose;
